import { createContext } from 'react';
import type { RewardsCoordinator } from './RewardsCoordinator';

export const RewardsCoordinatorContext = createContext<RewardsCoordinator | null>(null);
